import { createContext, useContext } from 'react';

const tabContext = createContext<number | undefined>(undefined);
tabContext.displayName = 'TabContext';
export const { Provider: TabContextProvider, Consumer: TabContextConsumer } = tabContext;

export const useTabContext = () => useContext(tabContext);
